<template>
  <div class="elevador-box">
    <img class="elevador-img" src="/img/elevador.png" alt>
    <div
      v-if="sensorsTemp[0]"
      id="t1"
      :class="'lado-esquerdo linha-6 valor-sensor'+' border-'+sensorsTemp[0].state"
    >
      <p>{{sensorsTemp[0].value}} {{sheriff.configuration.temperatureUnit}}</p>
    </div>
    <div
      v-if="sensorsTemp[1]"
      id="t2"
      :class="'lado-direito linha-5 valor-sensor'+' border-'+sensorsTemp[1].state"
    >
      <p>{{sensorsTemp[1].value}} {{sheriff.configuration.temperatureUnit}}</p>
    </div>
    <div
      v-if="sensorsTemp[2]"
      id="t3"
      :class="'lado-esquerdo linha-1 valor-sensor'+' border-'+sensorsTemp[2].state"
    >
      <p>{{sensorsTemp[2].value}} {{sheriff.configuration.temperatureUnit}}</p>
    </div>
    <div
      v-if="sensorsTemp[3]"
      id="t4"
      :class="'lado-direito linha-1 valor-sensor'+' border-'+sensorsTemp[3].state"
    >
      <p>{{sensorsTemp[3].value}} {{sheriff.configuration.temperatureUnit}}</p>
    </div>
    <div
      v-if="sensorsTemp[4]"
      id="t5"
      :class="'lado-esquerdo linha-2 valor-sensor'+' border-'+sensorsTemp[4].state"
    >
      <p>{{sensorsTemp[4].value}} {{sheriff.configuration.temperatureUnit}}</p>
    </div>
    <div
      v-if="sensorsMisalignment[0]"
      id="d1"
      :class="'lado-esquerdo linha-4 valor-sensor'+' border-'+sensorsMisalignment[0].state"
    >
      <p>{{sensorsMisalignment[0].state}}</p>
    </div>
    <div
      v-if="sensorsMisalignment[1]"
      id="d2"
      :class="'lado-direito linha-4 valor-sensor'+' border-'+sensorsMisalignment[1].state"
    >
      <p>{{sensorsMisalignment[1].state}}</p>
    </div>
    <div
      v-if="sensorsMisalignment[2]"
      id="d3"
      :class="'lado-esquerdo linha-3 valor-sensor'+' border-'+sensorsMisalignment[2].state"
    >
      <p>{{sensorsMisalignment[2].state}}</p>
    </div>
    <div
      v-if="sensorsMisalignment[3]"
      id="d4"
      :class="'lado-direito linha-3 valor-sensor'+' border-'+sensorsMisalignment[3].state"
    >
      <p>{{sensorsMisalignment[3].state}}</p>
    </div>
    <div
      id="m1"
      v-if="sensorsMovement[0]"
      :class="'lado-esquerdo linha-5 valor-sensor'+' border-'+sensorsMovement[0].state"
    >
      <p>{{sensorsMovement[0].value}} {{sheriff.configuration.movementUnit}}</p>
    </div>
    <div
      v-if="sensorsObstruction[0]"
      id="e1"
      :class="'lado-direito linha-2 valor-sensor'+' border-'+sensorsObstruction[0].state"
    >
      <p>{{sensorsObstruction[0].state}}</p>
    </div>
  </div>
</template>

<script>
import { filterSensorsByType } from "../../sheriffUtils";
export default {
  props: {
    sheriff: {
      required: true
    }
    // movementUnit:{},
    // temperatureUnit:{}
  },
  computed: {
    sensorsObstruction() {
      return filterSensorsByType(this.sheriff, "ObstructionSensor", true);
    },
    sensorsMisalignment() {
      return filterSensorsByType(this.sheriff, "MisalignmentSensor", true);
    },
    sensorsTemp() {
      return filterSensorsByType(this.sheriff, "TemperatureSensor", true);
    },
    sensorsMovement() {
      return filterSensorsByType(this.sheriff, "MovementSensor", true);
    }
  }
};
</script>

<style>
.elevador-box {
  width: 400px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 2rem;
}
.elevador-img {
  width: 100%;
  user-select: none;
}
.valor-sensor p {
  margin: 0 0;
  font-size: 1.2rem;
  /* color: #df691a; */
}
#m1 p {
  font-size: 0.8rem;
}
.valor-sensor {
  position: absolute;
  text-align: center;
  vertical-align: middle;

  width: 75px;
  height: 34px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.border-TRIGGERED {
  outline: 1px solid #f0ad4e;
  border: 1px solid #f0ad4e;
  background: #f0b86a;
}
.valor-sensor p {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.border-ERROR {
  outline: 1px solid #d43f3a;
  border: 1px solid #d43f3a;
  background: #d45652;
}
.border-WARNING {
  outline: 1px solid #df691a;
  border: 1px solid #df691a;
  background: rgb(214, 132, 78);
}
/* Lado esquerdo */
.lado-esquerdo {
}
/* Lado direito */
.lado-direito {
  left: 326px;
}
.linha-1 {
  top: 20px;
}
.linha-2 {
  top: 98px;
}
.linha-3 {
  top: 175px;
}
.linha-4 {
  top: 392px;
}
.linha-5 {
  top: 470px;
}
.linha-6 {
  top: 548px;
}
@media (max-width: 430px) {
  .elevador-box {
    width: 300px;
  }
  .valor-sensor {
    width: 56.22px;
    height: 25.5px;
  }
  .valor-sensor p {
    font-size: 0.8rem;
  }
  .lado-direito {
    left: 244.5px;
  }
  .linha-1 {
    top: 15px;
  }
  .linha-2 {
    top: 73.5px;
  }
  .linha-3 {
    top: 131.25px;
  }
  .linha-4 {
    top: 294px;
  }
  .linha-5 {
    top: 352.5px;
  }
  .linha-6 {
    top: 411px;
  }
}
</style>
